import { queryOptions, skipToken } from '@tanstack/react-query';

import { checkIsValwinAdmin } from './api';
import { getAllGroups } from './groups';
import { getPharmacists } from './pharmacist';

export const valwinAdminQueries = {
  all: (group: string) => ['valwinAdmin', group] as const,
  isValwinAdmin: (group: string) =>
    queryOptions({
      queryKey: [...valwinAdminQueries.all(group), 'isValwinAdmin'],
      queryFn: group ? () => checkIsValwinAdmin(group) : skipToken,
    }),
};

export const adminGroupQueries = {
  all: () => ['adminGroups'] as const,
  list: () =>
    queryOptions({
      queryKey: [...adminGroupQueries.all(), 'list'],
      queryFn: getAllGroups,
    }),
};

export const adminPharmacistQueries = {
  all: () => ['adminPharmacists'] as const,
  list: (pharmacyId: string) =>
    queryOptions({
      queryKey: [...adminPharmacistQueries.all(), 'list', pharmacyId],
      queryFn: pharmacyId ? () => getPharmacists(pharmacyId) : skipToken,
    }),
};
